export default function buildPatchFilterParam({
    apiEndpoint,
    apiTools
}) {
    return async function patchFilterParam(args) {
        const url = apiTools.resolveUrl({
            ...args,
            apiEndpoint: `${ apiEndpoint }/param` 
        })
       
        const res = await fetch(url, {
            method: 'PATCH',
            headers: {
                'Content-type': 'application/json'
            },
            credentials: 'include',
            body: JSON.stringify(args.body)
        });
        return await res.json();
    }
}